import React from "react";
import { Bar } from "react-chartjs-2";
import PropTypes from "prop-types";

const options = {
  indexAxis: "y",
  // Elements options apply to all of the options unless overridden in a dataset
  // In this case, we are setting the border of each horizontal bar to be 2px wide
  elements: {
    bar: {
      borderWidth: 1,
    },
  },
  responsive: true,
  plugins: {
    legend: {
      position: "right",
      display: false,
    },
  },
};

const BarChart = (props) => (
  <>
    <div className="header">
      <h3 className="title">{props.title}</h3>
    </div>
    <Bar data={props.data} options={options} />
  </>
);

BarChart.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
};

export default BarChart;
